export default "__VITE_ASSET__Bkbj0D87__"